import PageLoader from 'components/PageLoader';
import { Suspense, lazy } from 'react';
import { AppRouteComponentProps } from 'components/AppRoutes';

const MyOkrs = lazy(() => import('./MyOkrs.component'));

export default function MyOkrsPage(props: AppRouteComponentProps) {
  return (
    <Suspense fallback={<PageLoader open />}>
      <MyOkrs pageProps={props} />
    </Suspense>
  );
}
